import { useEffect, useRef, useState } from 'react';

interface PmsTooltipProps {
  label: string;
  side?: 'top' | 'bottom' | 'right';
  children: React.ReactElement;
}

const SIDE_CLASS: Record<NonNullable<PmsTooltipProps['side']>, string> = {
  top: '',
  bottom: ' pms-tt--bottom',
  right: ' pms-tt--right',
};

export function PmsTooltip({ label, side = 'top', children }: PmsTooltipProps) {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  function show(delay: number) {
    if (timerRef.current !== null) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setVisible(true), delay);
  }

  function hide() {
    if (timerRef.current !== null) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setVisible(false), 100);
  }

  useEffect(
    () => () => {
      if (timerRef.current !== null) clearTimeout(timerRef.current);
    },
    [],
  );

  return (
    <div
      className="pms-tt-wrap"
      onMouseEnter={() => show(300)}
      onMouseLeave={hide}
      onFocus={() => show(0)}
      onBlur={hide}
    >
      {children}
      {visible && (
        <div className={`pms-tt${SIDE_CLASS[side]}`} role="tooltip">
          {label}
          <div className="pms-tt__arrow" />
        </div>
      )}
    </div>
  );
}
